import { Column, Entity, PrimaryColumn } from "typeorm";

import { ConfigurationItem } from "../../_objects/tenant-config";
import { TenantIdSchemaBase } from "../interfaces/tenantId.base";

/**
 * TenantConfigSchema インターフェイス。
 */
export interface ITenantConfigSchema {
  key: string;
  value: string;
  valueType: string;
  groupKey: string;
  selectItems: string;
  tenantId: string;
}

@Entity()
export class TenantConfigSchema implements TenantIdSchemaBase {
  @PrimaryColumn()
  key: string;

  @Column({ nullable: true })
  value: string | null;

  @Column({ nullable: true })
  valueType: string | null;

  @Column({ nullable: true })
  groupKey: string | null;

  @Column({ nullable: true })
  selectItems: string | null;

  @Column({ nullable: true })
  tenantId: string | null;

  constructor(tenantId: string, configurationItem?: ConfigurationItem) {
    this.tenantId = tenantId;
    if (configurationItem) {
      this.key = configurationItem.key;
      this.groupKey = configurationItem.groupKey;
      this.selectItems = JSON.stringify(configurationItem.selectItems);

      if (configurationItem.value !== null) {
        this.value = configurationItem.value.toString();
        switch (typeof configurationItem.value) {
          case "string":
            this.valueType = "string";
            break;
          case "boolean":
            this.valueType = "boolean";
            break;
          case "number":
            this.valueType = "number";
            break;
        }
      }
    }
  }
}
